import { z } from 'zod';

/**
 * Team add validator with new schema
 * Phase 1: franchise (required), timezone (required), description (optional)
 */
export const teamAddValidator = z.object({
  name: z
    .string()
    .min(1, { message: 'Organization name is required' })
    .max(200, { message: 'Organization name must be less than 200 characters' }),
  franchise: z.enum(['orangeTheory'], {
    errorMap: () => ({ message: 'Invalid franchise. Currently only "orangeTheory" is supported.' }),
  }),
  timezone: z
    .string()
    .min(1, { message: 'Timezone is required' })
    .refine(
      tz => {
        try {
          Intl.DateTimeFormat(undefined, { timeZone: tz });
          return true;
        } catch {
          return false;
        }
      },
      { message: 'Invalid IANA timezone identifier' },
    ),
  description: z
    .string()
    .max(1000, { message: 'Description must be less than 1000 characters' })
    .optional()
    .or(z.literal('')),
  logo: z.string().optional(),
  leadEmails: z.array(z.string().email()).default([]),
});
